import renderSimplePopup from './render-simple-popup';
import renderCustomPopup from './render-custom-popup';

import { enum as popupTypes } from '../../../../../../../../enums/popup-types';

function renderPopup(popup, props) {
	switch (popup.type) {
		case popupTypes.simple:
			return renderSimplePopup(popup, props);
		case popupTypes.custom:
			return renderCustomPopup(popup, props);
	}
}

export default renderPopup;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/root/components/popup-window/popup/render-popup/index.js